import React from "react";
import { Box,  Stack, Typography, useTheme } from "@mui/material";
import { FaceBookIcon, InstagramIcon, LinkedinIcon, TwitterIcon } from "../icons";
import { MenuType } from ".";
import { useTranslation } from "react-i18next";
import { useLenis } from "src/context/LenisContext";
import {  menuItemStyle } from "src/styles";
import { useLocation, useNavigate } from "react-router-dom";

export const Footer: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const lenis = useLenis();
  const location = useLocation();
  const navigate = useNavigate();

  const menus: MenuType[] = [
    { title: t("header.home"), url: "/" },
    { title: t("header.service"), url: "/" },
    { title: t("header.choose"), url: "/" },
    { title: t("header.works"), url: "/" },
    { title: t("header.recruit"), url: "/" },
    // { title: t("header.company"), url: "#company" },
    { title: t("header.privacy"), url: "/privacy" },
    { title: t("header.security"), url: "/security" },
  ];

  const onMenuClick = (idx: number, url: string) => {
    if (url === "/") {
      if (location.pathname === "/") {
        return lenis?.scrollTo(`#section-${idx}`);
      } else {
        return navigate(url);
      }
    } else {
      return window.open(url, "_blank");
    }
  };

  return (
    <Stack
      justifyContent="center"
      sx={{
        width: "100%",
        height: "570px",
        backgroundColor: "#030711",
        color: "#fff",
        position: "fixed",
        bottom: 0,
      }}
    >
      <Stack
        sx={{
          position: "absolute",
          top: "20px",
          flexDirection: "column",
          gap: "20px",
          left: "20px",
          [theme.breakpoints.down("md")]: { right: "20px", left: "auto", top: "204px" },
        }}
      >
        <InstagramIcon />
        <FaceBookIcon />
        <TwitterIcon />
        <LinkedinIcon />
      </Stack>
      <Box
        sx={{
          margin: "0 auto",
          width: "80%",
          maxWidth: { xl: "960px" },
          display: "flex",
          justifyContent: "space-between",
          flexDirection: { xs: "column", md: "row" },
          // [theme.breakpoints.up("md")]: { gap: "10px" },
        }}
      >
        <Stack
          direction="column"
          justifyContent="space-between"
          sx={{
            width: "46%",
            [theme.breakpoints.down("md")]: { width: "100%" },
          }}
        >
          <Stack spacing={2} sx={{ [theme.breakpoints.down("md")]: { display: "none" } }}>
            <Typography fontSize="32px" fontFamily="RacingSansOne" color="white">
              SmartLabs
            </Typography>
            <Typography fontSize="20px" color="white" maxWidth="240px" fontWeight="500">
              {t("footer.slogan")}
            </Typography>
          </Stack>
          <Stack direction="column" sx={{ mt: "64px", [theme.breakpoints.down("md")]: { mt: 0 } }}>
            <Typography
              fontSize="14px"
              color="white"
              fontWeight={700}
              fontFamily="NotoSansJP"
              sx={{ mb: "30px", [theme.breakpoints.down("md")]: { mb: "15px" } }}
            >
              {t("footer.address.title")}
            </Typography>
            <Typography
              fontSize="15px"
              color="#6f6f6f"
              fontFamily="NotoSansJP"
              sx={{ mb: "28px", [theme.breakpoints.down("md")]: { mb: "14px", fontSize: "14px" } }}
            >
              {t("footer.address.ja")}
            </Typography>
            {/* <Typography
              fontSize="15px"
              color="#6f6f6f"
              fontFamily="NotoSansJP"
              sx={{ [theme.breakpoints.down("md")]: { fontSize: "14px" } }}
            >
              {t("footer.address.zh")}
            </Typography> */}
          </Stack>
        </Stack>
        <Stack
          direction="column"
          justifyContent="space-between"
          sx={{
            width: "46%",
            [theme.breakpoints.down("md")]: { width: "100%", mt: "64px" },
          }}
          spacing={8}
        >
          {/* <Stack sx={{ gap: "32px", [theme.breakpoints.down("md")]: { gap: "15px" } }}>
            <Typography fontSize="14px" color="white" fontWeight={700} fontFamily="NotoSansJP">
              GET IN TOUCH
            </Typography>
            <Stack spacing={2}>
              <Link
                href="mailto:contact@shuluntc.com"
                fontSize="17px"
                color="#f84525"
                sx={{ ...hoverUnderlineStyle, textDecoration: "none", [theme.breakpoints.down("md")]: { fontSize: "14px" } }}
              >
                contact@shuluntc.com
              </Link>
              <Typography
                fontSize="17px"
                color="#f84525"
                sx={{ ...hoverUnderlineStyle, [theme.breakpoints.down("md")]: { fontSize: "14px" } }}
              >
                +86 28 6073 9365
              </Typography>
            </Stack>
          </Stack> */}

          <Box>
            <Typography
              fontSize="14px"
              color="white"
              fontWeight={700}
              fontFamily="NotoSansJP"
              sx={{ mb: "30px", [theme.breakpoints.down("md")]: { mb: "15px" } }}
            >
              EXPLORE
            </Typography>
            <Stack direction="row" sx={{ flexWrap: "wrap" }}>
              {menus.map((item, index) => (
                <Box
                  key={index}
                  onClick={() => onMenuClick(index, item.url)}
                  sx={{
                    ...menuItemStyle,
                    ":hover": { color: "#f84525", "::after": { bgcolor: "#f84525" } },
                    [theme.breakpoints.down("md")]: { fontSize: "14px" },
                  }}
                >
                  {item.title}
                </Box>
              ))}
            </Stack>
            <Typography
              fontSize="16px"
              color="#6f6f6f"
              fontFamily="NotoSansJP"
              sx={{ mt: 1, [theme.breakpoints.down("md")]: { fontSize: "13px" } }}
            >
              {t("footer.copyright")}
            </Typography>
          </Box>
        </Stack>
      </Box>
    </Stack>
  );
};

export default Footer;
